/**
 * Created by Thomas Mark
 * Date: 28.05.2019
 * Description: text-Widget - Eingabe einer einzeiligen Zeichenkette
 *
 * Das text-Widget bietet die Möglichkeit einer einzeiligen Zeichenkette einzugeben.
 *
 * Die Steuerung des Widgets basiert auf folgender Widget-Struktur:
 *
 "widgets": [
    {
        "id": "speed",
        "group": null,
        "label": "Speed",
        "unitLabel": "",
        "description": "Text speed",
        "placeholder": "###",
        "widget": "MUInumber",
        "maxItems": 0,
        "visibleItems": 0,
        "value": 1234,
        "enums": []
        "length": 6,
        "validation": "^[0-9]?[0-9]{1}$|^100$",
        "validationState": null,
        "validationMessage": "please enter speed-value between 0 and 100"
    },
 *
 * Im number-Widget stehen folgende Widget-Attribute zur Verfügung:
 *
 * id            - Identifizierung des Feldes (muss eindeutig sein)
 * length        - Länge des Eingabefeldes bzw. Anzahl Zeichen
 * label         - Bezeichnung, die links neben dem Widget erscheint
 * unitLabel     - Mengeneinheit, die rechts neben dem Widget erscheint
 * description   - Genauere Beschreibung des Feldes, wird bei klick auf das Fragezeichen angezeigt
 * placeholder   - Text der im Eingabefeld erscheint, solange noch kein Wert eingegeben wurde
 * widget        - Bezeichnung des Widgets. Hier mit "number" belegt
 * maxItems      - Maximale Anzahl an auswählbaren Werten/Zeichen (hier ohne Bedeutung)
 * visibleItems  - Anzahl sichtbarer Werte in beiden Listen. Existieren mehr Werte, so erscheint ein vertikaler Scrollbalken
 * group         - Gruppenzuordnung (siehe dialog.group)
 * value         - Aktueller numerischer Wert
 * enums         - Alle Auswahlmöglichkeiten (hier ohne Bedeutung)
 * validation    - RegEx zur Validierung der Eingabe
 * validationState   - Zustand der Validierung
 * validationMessage - Fehlermeldung, falls Validierung erfolglos
 *
 * Der Komponente können folgende Eigenschaften/Werte übergeben werden:
 * field - field-Object
 * value - aktueller Wert
 * type - input-type . wird an das input-Tag weitergeleitet
 * icon - Bezeichnung des Icons, das rechts neben dem Eingabefeld erscheint.
 * onChange - callback-Funktion. Wird aufgerufen, wenn sich der Wert im Feld verändert
 * onKeyPress - callback-Funktion. Wird aufgerufen, wenn eine Taste gedrückt wurde
 * onBlur - callback-Funktion. Wird aufgerufen, wenn das Feld verlassen wird
 *
 */
import React from 'react';
import TextField from '@material-ui/core/TextField';

const Text = ({ field, value, onChange, onKeyPress, onBlur }) => {

    return (
        <TextField
            autoFocus={true}
            id={field.id}
            label={field.label}
            type='text'
            fullWidth
            value={value}
            onChange={(e) => onChange(e, e.target.value)}
            onKeyPress={onKeyPress}
            onBlur={onBlur}
            InputLabelProps={{ shrink: true }}
            InputProps={{ readOnly: field.disabled }}
            placeholder={field.placeholder}
            margin="normal"
        />
    )
}

export default Text